import { BeatLoader } from "react-spinners"
import { useModel } from "@stem-sims/nexus"
import { checkIfStudentClassExists, teacherFeatureAccess } from "shared/routes/teacher"
import CreateStudentAccountPage from "./CreateStudentAccountPage"
import UpdateStudentAccountInfoPage from "./UpdateStudentAccountInfoPage"
import NoStudentAccountAccessPage from "./NoStudentAccountAccessPage"

const StudentOptionsPage = () => {
    const { response: teacherHasStudentAccess, loading: loadingAccessCheck } = useModel({
        model: teacherFeatureAccess
    })

    const { response: studentAccountExists, loading, refreshModel } = useModel({
        model: checkIfStudentClassExists
    })

    if (loading || loadingAccessCheck) return <BeatLoader />

    if (!teacherHasStudentAccess) return <NoStudentAccountAccessPage />

  return (
    <div>
        {studentAccountExists ? <UpdateStudentAccountInfoPage /> : <CreateStudentAccountPage refreshCallback={refreshModel} />}
    </div>
  )
}

export default StudentOptionsPage
